export default __webpack_public_path__ + "media/images/sound-7a4b4986fc0338bddd3df823387b1238.svg";